import classNames from "classnames";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import "./TagCountList.scss";

interface TagCountListProps<T extends string> {
  counts: Map<T, number>;
  mapThingToText?: (thing: T) => string;
  thingRoute?: string;
  className?: string;
  sort?: "alphabetical" | "count";
}

export const TagCountList = <T extends string>({
  counts,
  className,
  mapThingToText,
  thingRoute,
  sort,
}: TagCountListProps<T>) => {
  const classes = classNames("count-by-thing-list", className);
  const contents = useMemo(() => {
    const sortedEntries = Array.from(counts.entries());
    if (sort === "alphabetical") {
      sortedEntries.sort((a, b) => a[0].localeCompare(b[0]));
    } else if (sort === "count") {
      sortedEntries.sort((a, b) => b[1] - a[1]);
    } else {
      // No sorting
    }

    return (
      <>
        {sortedEntries.map(([thing, count]) => {
          const thingContent = (
            <>
              <div className="count-by-thing-tag-label">
                {mapThingToText ? mapThingToText(thing as T) : thing}
              </div>
              <div className="count-by-thing-tag-count">
                {Number(count).toLocaleString()}
              </div>
            </>
          );

          if (thingRoute) {
            return (
              <Link
                key={thing}
                to={thingRoute.replace("$VALUE", encodeURIComponent(thing))}
                className="count-by-thing-tag"
              >
                {thingContent}
              </Link>
            );
          }

          return (
            <div key={thing} className="count-by-thing-tag">
              {thingContent}
            </div>
          );
        })}
      </>
    );
  }, [counts, sort, mapThingToText, thingRoute]);
  return <div className={classes}>{contents}</div>;
};
